import { useState } from "react";
import "./FloatingContact.css";
import { CONTACT } from "../../constants/contact";
import mapIcon from "../../assets/map.svg";
import zaloIcon from "../../assets/zalo.png";
import messengerIcon from "../../assets/messenger.svg";

function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="floating-contact">
      <button
        className="floating-contact-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Contact options"
      >
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
        </svg>
      </button>

      {isOpen && (
        <div className="floating-contact-menu">
          <a
            href={`https://maps.google.com/?q=${encodeURIComponent("652/14B Cộng Hoà, Tân Bình, Hồ Chí Minh")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="floating-contact-item maps"
            title="Bản đồ"
          >
            <img src={mapIcon} alt="Map" width="20" height="20" />
            <span>Map</span>
          </a>

          <a
            href="https://zalo.me"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-contact-item zalo"
            title="Zalo"
          >
            <img src={zaloIcon} alt="Zalo" width="20" height="20" />
            <span>Zalo</span>
          </a>

          <a
            href="https://m.me"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-contact-item messenger"
            title="Messenger"
          >
            <img src={messengerIcon} alt="Messenger" width="20" height="20" />
            <span>Messenger</span>
          </a>
        </div>
      )}
    </div>
  );
}

export default FloatingContact;
